module.exports = __webpack_public_path__ + "static/img/thumb8.02bcb27.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/thumbnails/thumb8.jpg
// module id = 649
// module chunks = 0